import React from 'react';
import {
  HStack, Icon, Text, VStack,
} from '@gluestack-ui/themed';
import { CheckCircle } from 'lucide-react-native';
import { useTranslation } from 'react-i18next';

import { formatEnglishDateLong, formatEnglishTime } from '@/common/utils/formatEnglishDateTime';

export type OralExamRegistrationCompletedProps = {
  /** Start of the attended booking (ISO). Omit when unknown. */
  attendedAtIso?: string | null;
};

/**
 * OralExamRegistrationCompleted
 * -----------------------------
 * Quiet "Completed" line inside the oral exam's "Your registration" section,
 * once the student has taken the exam.
 */
export function OralExamRegistrationCompleted({ attendedAtIso }: OralExamRegistrationCompletedProps) {
  const { t } = useTranslation();
  const attendedLabel = attendedAtIso
    ? `${formatEnglishDateLong(attendedAtIso)}, ${formatEnglishTime(attendedAtIso)}`
    : null;

  return (
    <HStack space="sm" alignItems="flex-start" testID="event-session-completed">
      <Icon as={CheckCircle} size="md" color="$statusSuccess" mt="$0.5" />
      <VStack flex={1}>
        <Text size="sm" color="$textHeading">{t('oralExam.registration.completed')}</Text>
        {attendedLabel ? (
          <Text size="sm" color="$textSubtle">
            {t('oralExam.registration.attendedOn', { date: attendedLabel })}
          </Text>
        ) : null}
      </VStack>
    </HStack>
  );
}
